import { lazy } from "react";
import { sentryCaptureError } from "utils/tracking/sentry";

export const Stripe = {
  Button: lazy(async () => {
    try {
      return await import("./button");
    } catch (error) {
      sentryCaptureError(error, {
        name: "failed to load Stripe button",
      });
      throw error;
    }
  }),
  CreditCard: lazy(async () => {
    try {
      return await import("./credit-card");
    } catch (error) {
      sentryCaptureError(error, {
        name: "failed to load Stripe credit-card",
      });
      throw error;
    }
  }),
  Provider: lazy(async () => {
    try {
      return await import("./provider");
    } catch (error) {
      sentryCaptureError(error, {
        name: "failed to load Stripe provider",
      });
      throw error;
    }
  }),
};
